import React from "react";
import { useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import { protectedRoutes } from "./ProtectedRoute";
import { publicRoutes } from "./PublicRoute";

export const AppRoutes = () => {
  const auth = useSelector((x) => x.auth);

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes]);

  return <>{element}</>;
};
